import React from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import SideBar from './components/Sidebar';
import sidebar_menu from './constants/sidebar-menu';

import './App.css';
import Login from "./pages/Login"
import Dashboard from './pages/Dashboard';
import GymMembers from './pages/GymMembers';
import GymDailyMembers from './pages/GymDailyMembers';
import GymActiveMembers from './pages/GymActiveMembers';
import GymInActiveMembers from './pages/GymInActiveMembers';

import NotFound from './pages/NotFound';

import Cookies from 'universal-cookie';

function App () {

  // Create a cookies instance
  const cookies = new Cookies();

  // Function to get the session token from the cookie
  const getSessionCookie = () => {
    return cookies.get('sessionToken');
  };

  const sessionToken = getSessionCookie()
  return(
    <>
    {
      (sessionToken && sessionToken.length > 20) ? (
      <>
        <Router>
          <div className='dashboard-container'>
            <SideBar menu={sidebar_menu} />
              
              <div className='dashboard-body'>
                  <Routes>
                    <Route path="*" element={<div>Not Found</div>} />
                    <Route path="/login" element={<Login />} />
                    <Route index element={<Dashboard />} />
                    <Route path="/gym-members" element={<GymMembers />} />
                    <Route path="/gym-daily-members" element={<GymDailyMembers />} />
                    <Route path="/gym-active-members" element={<GymActiveMembers />} />
                    <Route path="/gym-inactive-members" element={<GymInActiveMembers />} />
                  </Routes>
              </div>
          </div>
        </Router>
      </>


  )
  : (
    <>
   <Router>
      <div className='dashboard-container'>
        <SideBar menu={sidebar_menu} />
              
          <div className='dashboard-body'>
            <Routes>
              <Route path="*" element={<NotFound />} />
              <Route path="/login" element={<Login />} />
            </Routes>
          </div>
      </div>
    </Router>
    </>
    )
  }
    </>
)}

export default App;